/**
 * Created by RaoMeng on 2020/8/3
 * Desc: 话机话费预存付款页面
 */

import React, { Component } from 'react'
import { connect } from 'react-redux'
import { List, message, Skeleton } from 'antd'
import PhonesItem from '../../components/PhonesItem'
import PayableCostRecordItem from '../../components/PayableCostRecordItem'
import { fetchGet } from '../../utils/fetchRequest'
import { API } from '../../configs/api.config'
import { Toast } from 'antd-mobile'
import { getStrValue } from '../../utils/common'

class PayableCostRecord extends Component {

  constructor () {
    super()

    this.state = {
      isLoading: true,
      recordList: [],
    }
  }

  componentDidMount () {
    document.title = '交易记录'

    this.loadRecordList()
  }

  componentWillUnmount () {
    Toast.hide()
  }

  render () {
    const {
      isLoading,
      recordList,
    } = this.state

    return (
      <div>
        <Skeleton loading={isLoading} active paragraph={{ rows: 3 }}>
          <List className='phones-list-layout'
                dataSource={recordList}
                renderItem={recordBean => (
                  <List.Item>
                    <PayableCostRecordItem rechargeBean={recordBean}/>
                  </List.Item>
                )}/>
        </Skeleton>
      </div>
    )
  }

  loadRecordList = () => {
    const { studentId, schoolId } = this.props
    let { recordList } = this.state
    recordList.length = 0
    this.setState({
      isLoading: true,
    })
    Toast.loading('', 0)
    fetchGet(API.INFO_CALL_RECORD_LIST, {
      studentId, schoolId,
    }).then(response => {
      Toast.hide()
      if (response && response.data && response.data.length > 0) {
        recordList = response.data
      }
      this.setState({
        recordList,
        isLoading: false,
      })
    }).catch(error => {
      Toast.hide()
      this.setState({
        recordList,
        isLoading: false,
      })
      if (typeof error === 'string') {
        Toast.fail(error, 2)
      } else {
        Toast.fail('请求异常', 2)
      }
    })
  }
}

let mapStateToProps = (state) => ({
  studentId: state.redUserInfo.parent.student.stuId,
  schoolId: state.redUserInfo.user.schoolId,
  userInfo: { ...state.redUserInfo },
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(
  PayableCostRecord)
